// @ts-nocheck
/* eslint-disable */
export const twotoneDiagramIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"><path d="M2 2v17c0 1.66 1.34 3 3 3h17"/><path d="m5 17 4.59-5.36c.76-.88 2.11-.94 2.93-.11l.95.95c.82.82 2.17.77 2.93-.11L21 7" opacity=".4"/></g></svg>`,
    name: 'twotone-diagram' as const
};